import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers/default-layout';
import { PublicLayoutComponent } from './containers/public-layout/public-layout.component';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/pages/login/login.component';
import { HomeComponent } from './views/pages/home/home.component';
import { ListaComponent } from './views/pages/categoria/lista/lista.component'
import { PerfilComponent } from './views/pages/perfil/perfil.component';
import { NominarComponent } from './views/pages/nominar/nominar.component';
import { ContactoComponent } from './views/pages/contacto/contacto.component';
import { InformacionComponent } from './views/pages/informacion/informacion.component';
import { ValidarAuthService } from './services/validar-auth/validar-auth.service';
import { TerminosComponent } from './views/pages/terminos/terminos.component';
import { NgxEditorModule } from 'ngx-editor';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    component: PublicLayoutComponent,
    data: {
      title: 'Guatemaltecos Ilustres'
    },
    children: [{
      path: '',
      component: HomeComponent
    }, {
      path: 'categoria/:filtro',
      component: ListaComponent
    }, {
      path: 'categoria',
      component: ListaComponent
    }, {
      path: 'periodos',
      component: ListaComponent,
      data: { periodosActivos: true }
    },
    {
      path: 'perfil/:id',
      component: PerfilComponent
    },
    {
      path: 'nominar',
      component: NominarComponent
    }, {
      path: 'contacto',
      component: ContactoComponent
    },
    {
      path: 'sobre-el-galardon',
      component: InformacionComponent
    },
    {
      path: 'terminos',
      loadChildren: () =>
        import('./views/pages/terminos/terminos.module').then((m) => m.TerminosModule)
    },
    {
      path: 'preguntas-frecuentes',
      loadChildren: () => import('./views/pages/preguntas-frecuentes/preguntas-frecuentes.module').then((m) => m.PreguntasFrecuentesModule)
    }, {
      path: 'politicas',
      loadChildren: () => import('./views/pages/politicas/politicas.module').then((m) => m.PoliticasModule)
    }
    ]
  },
  {
    path: 'dashboard',
    component: DefaultLayoutComponent,
    resolve: {
      logged: ValidarAuthService
    },
    data: {
      title: 'Dashboard'
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./views/pages/usuarios/usuarios.module').then((m) => m.UsuariosModule)
      },
      {
        path: 'configuracion',
        loadChildren: () => import('./views/pages/configuracion/configuracion.module').then((m) => m.ConfiguracionModule)
      },
      {
        path: 'contactos',
        loadChildren: () => import('./views/pages/contactos/contactos.module').then((m) => m.ContactosModule)
      },
      {
        path: 'nominados',
        loadChildren: () => import('./views/pages/admin-perfiles/admin-perfiles.module').then((m) => m.AdminPerfilesModule)
      },
      {
        path: 'terminos',
        loadChildren: () => import('./views/pages/terminos/terminos.module').then((m) => m.TerminosModule)
      }, {
        path: 'registros',
        loadChildren: () => import('./views/pages/votos-registros/votos-registros.module').then((m) => m.VotosRegistrosModule)
      }
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [
    NgxEditorModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
